import { Shipment } from "@/model/transportorder/transportOrder"
import moment from "moment"

export const sortShipmentByDueDate = (shipments: Shipment[]): Shipment[] => {
    return shipments.toSorted((a, b) => {

        const aDue =
            a.currentTransportLeg.arrivalEstimatedAt?.time_to ??
            (a.isEndOfTransportChain ?
                a.endOfTransportChain.deliveryEstimatedAt?.time_to : 0)
        const bDue =
            b.currentTransportLeg.arrivalEstimatedAt?.time_to ??
            (b.isEndOfTransportChain ?
                b.endOfTransportChain.deliveryEstimatedAt?.time_to : 0)
        /*
           if one of the time windows is undefined it will be sorted below the other one,
           because moment(0) results in 1970-01-01
           whereas moment(undefined) results in "now"
         */
        return moment(aDue).diff(moment(bDue))
    })
}
